module.exports = __webpack_public_path__ + "static/media/ic-play-alt.b0df83a1.svg";